import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Loading = () => {
  // Customize the loading spinner icon
  const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Spin indicator={antIcon} tip="Loading..." size="large" />
    </div>
  );
};

export default Loading;
